import { useState, useCallback } from "react";
import { mapValues, every } from "lodash";

/**
Each validation should return a boolean
The validation should return true if it fails

Usage:

function MyInput() {

  const [isValid, validations, validate] = useValidations({
    isEmpty: value => value.length === 0,
    isOutOfBounds: value => Number(value) < 0 || Number(value) > 10
  });

  function validateChange(e) {
    validate(e.target.value);
  }

  return (
    <>
      <Input onChange={validateChange} error={!isValid} />

      {validations.isEmpty && "Input is empty"}
      {validations.isOutOfBounds && "Input is less than 0 or greater than 10"}
    </>
  )
}
*/

function useValidations(rules) {
  const [metadata, setMetadata] = useState({
    isValid: true,
    validations: {}
  });

  function validate(value) {
    const validations = mapValues(rules, validator => validator(value));
    const isValid = every(validations, value => value === false);
    setMetadata({ isValid, validations });
    return [isValid, validations];
  }

  return [metadata.isValid, metadata.validations, useCallback(validate, [])];
}

export default useValidations;
